import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
import DropdownToggle from "components/dropdown-toggle/DropdownToggle";
import PatientCreatorContainer from "components/patient-editor/PatientCreatorContainer";
import { useSubscription } from "contexts/subscription-context";
import messages from "messages";
import { useState } from "react";
import { Dropdown /*, OverlayTrigger, Tooltip */ } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { showAddToCalendar } from "store/calendarSidebarSlice";
import { AmplitudePageName, track } from "utils/amplitude";
import styles from "./styles.module.scss";
import { getDefaultSessionDateTime } from "./utils/getDefaultSessionDateTime";

type Props = {
  timezone: string;
  user: User | null | undefined;
  analyticsPageName: AmplitudePageName;
};

const CreateSession = ({ timezone, user, analyticsPageName }: Props) => {
  const { restrictAccessToPaidFeature } = useSubscription();
  const dispatch = useDispatch();
  // create patient dropdown
  const [showPatientCreator, setshowPatientCreator] = useState(false);

  return (
    <>
      {showPatientCreator && (
        <PatientCreatorContainer
          show={true}
          onHide={() => setshowPatientCreator(false)}
          amplitudePageName={analyticsPageName}
        />
      )}
      {/* <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="button-tooltip">Create a new session [Ctrl+N]</Tooltip>
        }
      > */}
      <DropdownToggle
        title={
          <div className={"d-flex align-items-center"}>
            <OutlinePlus16 className="mr-2 white" />
            {messages.create}
          </div>
        }
        variant={"primary"}
        className={styles["create-session"]}
        hideCaret
      >
        <Dropdown.Item
          onClick={() => {
            track(
              analyticsPageName,
              "create-1-to-1-session-dropdown-item",
              "click",
            );
            dispatch(
              showAddToCalendar({
                hasInitialTime: true,
                defaultStartTime: +getDefaultSessionDateTime(timezone),
              }),
            );
          }}
        >
          {messages["11Session"]}
        </Dropdown.Item>
        {/* TODO: remove disabled when done.
        Also add analytics tracking. */}
        <Dropdown.Item disabled={true}>{messages.groupSession}</Dropdown.Item>
        {restrictAccessToPaidFeature(user) ? null : (
          <Dropdown.Item
            onClick={() => {
              track(analyticsPageName, "create-patient-dropdown-item", "click");

              setshowPatientCreator(true);
            }}
          >
            Create patient
          </Dropdown.Item>
        )}
      </DropdownToggle>
      {/* </OverlayTrigger> */}
    </>
  );
};

export default CreateSession;
